module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightlightsnow-b2464d6f3198d31018a11976fbc39fbe.svg";